import { Table } from '@mui/material';
import styled from 'styled-components';

export const StyledFeatureOptionsTable = styled(Table)`
  && {
    td {
      border: 1px solid ${({ theme }) => theme.palette.divider};
      min-width: 10rem;

      &:first-of-type {
        ${({ theme }) => theme.typography.p7};
      }
    }
  }
`;
